module.exports = "/assets/delice-page/drop.jpg?/lt703G";